
export const formatNumber = (val: number | string) => {

    val = Math.round(Number(val));
    return  isNaN(val)? undefined: new Intl.NumberFormat("en-US").format(val);


}